import { render, staticRenderFns } from "./DnsValidator.vue?vue&type=template&id=5c588e10&"
import script from "./DnsValidator.vue?vue&type=script&lang=js&"
export * from "./DnsValidator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports